import React, { FC, Fragment, useCallback, useEffect, useState } from "react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import CommentListing from "components/CommentListing/CommentListing";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import { DateRage } from "components/HeroSearchForm/StaySearchForm";
import useWindowSize from "hooks/useWindowResize";
import moment from "moment";
import {
  FocusedInputShape
} from "react-dates";
import Badge from "shared/Badge/Badge";
import ButtonCircle from "shared/Button/ButtonCircle";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import NcImage from "shared/NcImage/NcImage";
import LikeSaveBtns from "./LikeSaveBtns";
import ModalPhotos from "./ModalPhotos";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import StayDatesRangeInput from "components/HeroSearchForm/StayDatesRangeInput";
import MobileFooterSticky from "./MobileFooterSticky";
import { HotelType,bookingType,offerType, ratingType } from "data/types";
import {useHistory, useParams} from "react-router-dom";
import SectionGridAuthorBox from "components/SectionGridAuthorBox/SectionGridAuthorBox";
import useAuth from "components/Authprovider/Auth";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import toast from "react-hot-toast";
import { fetchData} from "data/api/fetch";
import StartRating from "components/StartRating/StartRating";
import history from "hooks/history";
import { reLoadPage } from "hooks/reLoadPage";
//




export interface ListingStayDetailPageProps {
  className?: string;
  isPreviewMode?: boolean;
}

const PHOTOS: string[] = [
  "https://images.pexels.com/photos/6129967/pexels-photo-6129967.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
  "https://images.pexels.com/photos/7163619/pexels-photo-7163619.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  "https://images.pexels.com/photos/6527036/pexels-photo-6527036.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  "https://images.pexels.com/photos/6969831/pexels-photo-6969831.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
];


type typeParams = {
  id: any;
};


export function diffDays(date1: moment.Moment | null, date2: moment.Moment | null): number {
  // Use the optional chaining operator to check if the parameters are null or undefined
  // Use the nullish coalescing operator to provide a default value of the current date
  date1 = date1?.clone() ?? moment();
  date2 = date2?.clone() ?? moment();
  // Use the diff method to get the difference in milliseconds
  let diff = date1.diff(date2,"days");
  // Return the absolute value of the difference in days
  return Math.abs(diff);
}





const ListingStayDetailPage: FC<ListingStayDetailPageProps> = ({
  className = "",
  isPreviewMode,
}) => {
  

 //
 const {token} = useAuth()
 const navigater = useHistory()
 
  const [isOpen, setIsOpen] = useState(false);
  const [openFocusIndex, setOpenFocusIndex] = useState(0);
  const [selectedDate, setSelectedDate] = useState<DateRage>({
    startDate: moment().add(0, "days"),
    endDate: moment().add(2, "days"),
  });

  const [offerSelected, setOfferSelected] = useState("")
  const [offerPrice, setOfferPrice] = useState(0)
  const [rooms, setRooms] = useState(1)
  const [total, setTotal] = useState(0)
  const [guest, setGuest] = useState(1)


  //
  const [count, setCount] = useState(5);
  const [comment,setComment] = useState("");
  //
  const [comments,setComments] = useState<ratingType[]>()

  const { id } = useParams<typeParams>();

  const [data,setData] = useState<HotelType>()
  const [offer,setOffers] = useState<offerType[]>()

  

  const onOptionChange = (e:React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value)
    setOfferSelected(e.target.value)
  }

  const  addComment = (e: React.ChangeEvent<HTMLInputElement>)=> {
    console.log(e.target.value)
    setComment(e.target.value)
  }

  

  const calcTotal = useCallback(() => {

    if (offerPrice && selectedDate && rooms && rooms >= 1){

      const totalAmount = diffDays(selectedDate.startDate,selectedDate.endDate)*offerPrice*rooms;
      setTotal(totalAmount)

    }else if(data?.daily_room_price && selectedDate && rooms && rooms >= 1 ){

      const totalAmount = diffDays(selectedDate.startDate,selectedDate.endDate)*data.daily_room_price*rooms;
      setTotal(totalAmount)

    }

  },[offerPrice,selectedDate,rooms,data?.daily_room_price])

  useEffect(()=>{
    calcTotal()
    console.log(total)
  },[offerPrice,selectedDate,rooms])


  //Headers for all http/s requests
  const headers = {
    "Accept": "application/json",
    "Authorization": `Bearer ${token}`,
  };

  //Add review function
  const handleComment = useCallback(async ()=>{

    const data = {rating: count,comment: `${comment}`};
    console.log(data);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization": "Bearer " +token},
      body: JSON.stringify(data),
    };

    const postData = () => {
      return fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+id+'/ratings', requestOptions)
      .then((response) =>{
        if (response.status === 200 || response.status === 201) {
          // Parse the response as JSON and resolve the promise with the data
          return response.json();
        } else {
          // Reject the promise with an error message
          new Error(`Fetch failed: ${response.status} ${response.statusText}`);
        }
      })
      .then((result) => reLoadPage());
    };

    const notify = () => {
      toast.promise(postData(), {
        loading: "Sending data...",
        success: (result) => `Data sent successfully`,
        error: (error) => `Something went wrong: ${error}`,
      });
    };

    notify()
    
  },[comment])

  const checkIn = selectedDate.startDate?.format('YYYY-MM-DD HH:mm:ss');
  const checkOut = selectedDate.endDate?.format('YYYY-MM-DD HH:mm:ss');

  const room_type = offerSelected.toLowerCase()

  const handleBooking = async ()=>{

    const data = {hotel_id: id,number_of_guests: guest,number_of_rooms: rooms,room_type: room_type,daily_price: offerPrice,total_price: total,check_in_date: checkIn,check_out_date: checkOut};

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization": "Bearer " +token},
      body: JSON.stringify(data),
    };

    const postData = fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+id+'/booking', requestOptions)

    toast.promise(postData, {
      loading: "Creating a booking....",
      success: (data: any) => `Successful`,
      error: (error) => `Unable to make booking`,
    });

    postData.then((data: any) => {
      // Use setData to update the state with the data
      navigater.push("/bookings");
    });
    /*const postData = () => {
      return fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+id+'/booking', requestOptions)
      .then((response) =>{
        if (response.status === 200 || response.status === 201) {
          // Parse the response as JSON and resolve the promise with the data
          let data  = response.json();
          if (data.success) {
          return response.json();
        } else {
          // Reject the promise with an error message
          new Error(`Fetch failed: ${response.status} ${response.statusText}`);
        }
      })
      .then((result) => console.log(result));
    };*/

    /*const notify = () => {
      toast.promise(postData(), {
        loading: "Sending data...",
        success: (result: any) => {
          setBooking(result.booking);
          return `Success`
        },
        error: (error) =>{
          return `Booking failed to be created`
        } ,
      });
    };
    
    notify()*/
    
  }
  
 

  useEffect(() =>{
    const getHotels = fetchData(`https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/`+id,{},headers)

    const getHotelOffers = fetchData(`https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/`+id+'/accommodation-offers',{},headers)

    toast.promise(getHotels, {
      loading: "Loading....",
      success: (data: any) => `Successful`,
      error: (error) => `No search results found`,
    });

    getHotels.then((data: any) => {
      // Use setData to update the state with the data
      setData(data.data)
    });

    getHotelOffers.then((data: any) => {
      // Use setData to update the state with the data
      setOffers(data)
    });
     
  },[id])


 

  useEffect(()=>{
    const getReviews = fetchData('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+id+'/ratings',{},headers)

    toast.promise(getReviews, {
      loading: "Loading reviews....",
      success: (data: any) => `Successful`,
      error: (error) => `Unable to retrieve reviews`,
    });

    getReviews.then((data: any) => {
      // Use setData to update the state with the data
      setComments(data.ratings)
    });
    
  },[id])

  
////////////////////////////////
const windowSize = useWindowSize();

const getDaySize = () => {
  if (windowSize.width <= 375) {
    return 34;
  }
  if (windowSize.width <= 500) {
    return undefined;
  }
  if (windowSize.width <= 1280) {
    return 56;
  }
  return 48;
  };


  const handleOpenModal = (index: number) => {
    setIsOpen(true);
    setOpenFocusIndex(index);
  };

  const handleCloseModal = () => setIsOpen(false);

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        {/* 1 */}
      
        {/* 2 */}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold">
          {data?.name}
        </h2>

        {/* 3*/}
        <div className="flex items-center space-x-4">
          <StartRating />
          <span>·</span>
          <span>
            <i className="las la-map-marker-alt"></i>
            <span className="ml-1"> {data?.address} </span>
          </span>
        </div>

        {/* 4 */}
        <div className="flex items-center">
          {/*<Avatar hasChecked  sizeClass="h-10 w-10" radius="rounded-full" />*/}
          <span className="ml-2.5 text-neutral-500 dark:text-neutral-400">
            Hosted by{" "}
            <span className="text-neutral-900 dark:text-neutral-200 font-medium">
              {data?.name}
            </span>
          </span>
        </div>

        {/* 5 */}
        <div className="w-full border-b border-neutral-100 dark:border-neutral-700" />

        {/* 6 */}
        <div className="flex items-center justify-between xl:justify-start space-x-8 xl:space-x-12 text-sm text-neutral-700 dark:text-neutral-300">
          <div className="flex items-center space-x-3 ">
            <i className=" las la-bed text-2xl "></i>
            <span className="">
              {data?.no_of_double_rooms} <span className="hidden sm:inline-block">Double Rooms</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className=" las la-bed text-2xl"></i>
            <span className=" ">
            {data?.no_of_single_rooms}  <span className="hidden sm:inline-block">Single Rooms</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className=" las la-bed text-2xl"></i>
            <span className=" ">
            {data?.no_of_suite_rooms}  <span className="hidden sm:inline-block">Suites</span>
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderSection2 = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Stay information</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <span>
            {data?.description}
          </span>
        </div>
      </div>
    );
  };

  const renderSection6 = () => {
    
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Reviews ({comments?.length} reviews)</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* Content */}
        <div className="space-y-5">
          <FiveStartIconForRate  iconClass="w-6 h-6" className="space-x-0.5"  getSelected={(point)=> setCount(Math.abs(point))} />
          <div className="relative">
            <input
              type="text"
              className="h-16 px-4 py-3 rounded-3xl"
              placeholder="Share your thoughts ..."
              value={comment}
              onChange={(e)=>setComment(e.target.value)}
            />
            <ButtonCircle
              className="absolute right-2 top-1/2 transform -translate-y-1/2"
              size=" w-12 h-12 "
              onClick={handleComment}
            >
              <ArrowRightIcon className="w-5 h-5" />
            </ButtonCircle >
          </div>
        </div>

        {/* comment */}
        <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
          {comments &&(
            comments.map((comment) => (
              <CommentListing key={comment.id} hotel_id={id} data={comment}/>
            ))
          )}
          
          <div className="pt-8">
            <ButtonSecondary>View more 20 reviews</ButtonSecondary>
          </div>
        </div>
      </div>
    );
  };

  const renderSection7 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Location</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            {data?.address}
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* MAP */}
      </div>
    );
  };

  const renderRadio = (
    data: offerType,
    name: string,
    id: string,
    label: string,
    key?: any,
  ) => {
    return (
      <div className="flex items-center" key={key}>
        <input
          id={id}
          name={name}
          type="radio"
          value={id}
          checked={offerSelected === data.room_type}
          onChange={(e)=>{
            onOptionChange(e)  
            setOfferPrice(data.daily_price)
          }}
          className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
        />
        <label
          htmlFor={id + name}
          className="ml-3 block text-sm font-medium text-neutral-700 dark:text-neutral-300"
        >
          {label}
        </label>
      </div>
    );
  };

  const renderSidebar = () => {
    return (
      <div className="listingSectionSidebar__wrap shadow-xl">
        {/* PRICE */}
        <div className="flex justify-between">
          <span className="text-3xl font-semibold">
            ${offerPrice ? offerPrice : data?.daily_room_price}
            <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              /night
            </span>
          </span>
          <StartRating />
        </div>

        {/* FORM */}
        <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <StayDatesRangeInput
            wrapClassName="divide-x divide-neutral-200 dark:divide-neutral-700 !grid-cols-1 sm:!grid-cols-2"
            onChange={(date) => setSelectedDate(date)}
            fieldClassName="p-3"
            defaultValue={selectedDate}
            anchorDirection={"right"}
            className="nc-ListingStayDetailPage__stayDatesRangeInput flex-1"
          />
          <div className="w-full border border-neutral-200 dark:border-neutral-700"></div>
          <div className="relative flex items-center justify-evenly px-5 py-6 ">
            {offer &&(
              offer.map((offer) => (
                renderRadio(offer,"Offer", offer.room_type,`${offer.room_type} ($${offer.daily_price})`,offer.created_at)
              ))
            )}
          </div>
          <div className="w-full border border-neutral-200 dark:border-neutral-700"></div>
          <div className="relative flex flex-col px-5 py-6 space-y-5">
            <NcInputNumber label="Number of rooms" min={1} max={10} defaultValue={rooms} onChange={(value)=> setRooms(value)}/>
          </div>
          <div className="w-full border border-neutral-200 dark:border-neutral-700"></div>
          <div className="relative flex flex-col px-5 py-6 space-y-5">
            <NcInputNumber label="Number of guests" min={1} max={10} defaultValue={guest} onChange={(value)=> setGuest(value)}/>
          </div>
          
          {/*<GuestsInput
            className="nc-ListingStayDetailPage__guestsInput flex-1"
            fieldClassName="p-3"
            defaultValue={{
              guestAdults: 0,
              guestChildren: 0,
              guestInfants: 0,
            }}
            onChange={(data?) =>{
                const total = data.guestAdults? + data.guestChildren?
                setGuest()
              }
            }}
            hasButtonSubmit={false}
          />*/}
        </form>

        {/* SUM */}
        <div className="flex flex-col space-y-4">
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>${offerPrice ? offerPrice : data?.daily_room_price} x {diffDays(selectedDate.startDate,selectedDate.endDate)} nights</span>
            <span>x {rooms} rooms</span>
          </div>
         {/*<div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Service charge</span>
            <span>%5</span>
          </div>*/}
          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex justify-between font-semibold">
            <span>Total</span>
            <span>${total}</span>
          </div>
        </div>

        {/* SUBMIT */}
        <ButtonPrimary onClick={handleBooking}>Reserve</ButtonPrimary>
      </div>
    );
  };

  return (
    <div
      className={`ListingDetailPage nc-ListingStayDetailPage ${className}`}
      data-nc-id="ListingStayDetailPage"
    >
      {/* SINGLE HEADER */}
      <>
        <header className="container 2xl:px-14 rounded-md sm:rounded-xl">
          <div className="relative grid grid-cols-3 sm:grid-cols-4 gap-1 sm:gap-2">
            <div
              className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
              onClick={() => handleOpenModal(0)}
            >
              <NcImage
                containerClassName="absolute inset-0"
                className="object-cover w-full h-full rounded-md sm:rounded-xl"
                src={data?.image}
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>
            {PHOTOS.map((item, index) => (
              <div
                key={index}
                className={`relative rounded-md sm:rounded-xl overflow-hidden ${
                  index >= 3 ? "hidden sm:block" : ""
                }`}
              >
                <NcImage
                  containerClassName="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5"
                  className="object-cover w-full h-full rounded-md sm:rounded-xl "
                  src={item || ""}
                />

                {/* OVERLAY */}
                <div
                  className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                  onClick={() => handleOpenModal(index + 1)}
                />
              </div>
            ))}

            <div
              className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
              onClick={() => handleOpenModal(0)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
              <span className="ml-2 text-neutral-800 text-sm font-medium">
                Show all photos
              </span>
            </div>
          </div>
        </header>
        {/* MODAL PHOTOS */}
        <ModalPhotos
          imgs={PHOTOS}
          isOpen={isOpen}
          onClose={handleCloseModal}
          initFocus={openFocusIndex}
          uniqueClassName="nc-ListingStayDetailPage-modalPhotos"
        />
      </>

      {/* MAIn */}
      <main className="container relative z-10 mt-11 flex flex-col lg:flex-row ">
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
          {renderSection1()}
          {renderSection2()}
          {/*renderSection3()*/}
          {/*renderSection4()*/}
          {/*renderSectionCheckIndate()*/}
          {/*renderSection5()*/}
          {renderSection6()}
          {renderSection7()}
          {/*renderSection8()*/}
        </div>

        {/* SIDEBAR */}
        <div className="hidden lg:block flex-grow mt-14 lg:mt-0">
          <div className="sticky top-28">{renderSidebar()}</div>
        </div>
      </main>

      {/* STICKY FOOTER MOBILE */}
      {!isPreviewMode && <MobileFooterSticky dailyPrice={data?.daily_room_price}/>}

      {/* OTHER SECTION */}
      {!isPreviewMode && (
        <div className="container py-24 lg:py-32">
          {/* SECTION 1 */}
          <div className="relative py-16">
            <BackgroundSection className="bg-primary-50 dark:bg-black dark:bg-opacity-20" />
            <SectionGridAuthorBox />
          </div>

          {/* SECTION */}
          {/*<SectionSubscribe2 className="pt-24 lg:pt-32" />*/}
        </div>
      )}
    </div>
  );
};

export default ListingStayDetailPage;

